module.exports = __webpack_public_path__ + "assets/logo-black.99ac11aa.svg";